import React from "react";
import Gallery from "./Gallery";
export default function GalleryApp(){
    return(
        <>
        <Gallery/>
        </>
    )
}